import { render } from "./TopStoresBlock.vue?vue&type=template&id=6914fa6e"
import script from "./TopStoresBlock.vue?vue&type=script&lang=js"
export * from "./TopStoresBlock.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./TopStoresBlock.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_8fd35eee%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Froadmap%2FTopStoresBlock.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__